import React from 'react'
import Abouttop from './Abouttop/Abouttop'
import About2ndSection from './About2ndSection/About2ndSection'
import Aboutteam from './AboutTeam/Aboutteam'
import AboutSer from './AboutSer/AboutSer'

const About = () => {
  return (
   <>
    <Abouttop/>
    <About2ndSection/>
    <Aboutteam/>
    <AboutSer/>
   </>
  )
}

export default About